import React, { useContext, useEffect, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const DashboardContext = React.createContext();


export const DashboardProvider = ({ children }) => {


    const { btoken, stoken } = useUserContext();


    let data = { btoken, stoken };
    const {
        loading: dashboardLoading, data: dashboardData, fetchData: getDashboardData
    } = useFetch('/dashboard.home', data);
    const {
        loading: salesOverviewLoading, data: salesOverviewData, fetchData: getSalesOverviewData
    } = useFetch('/dashboard/sales.overview', data);
    const {
        loading: inventoryOverviewLoading, data: inventoryOverviewData, fetchData: getInventoryOverviewData
    } = useFetch('/dashboard/inventory.summary', data);
    const {
        loading: dashboardGraphLoading, data: dashboardGraphData, fetchData: getDashboardGraphData
    } = useFetch('/dashboard/graph', data = { ...data, year: '2025' });

    return (
        <DashboardContext.Provider value={{

            dashboardLoading, dashboardData, getDashboardData,
            salesOverviewLoading, salesOverviewData, getSalesOverviewData,
            inventoryOverviewLoading, inventoryOverviewData, getInventoryOverviewData,
            dashboardGraphLoading, dashboardGraphData, getDashboardGraphData,

        }}>
            {children}
        </DashboardContext.Provider>
    );
};

// make sure use
export const useDashboardContext = () => {
    return useContext(DashboardContext);
};
